import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="bg-[var(--indigo)] text-[var(--cream)] relative overflow-hidden"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-6">
            <div className="font-serif-display text-3xl md:text-4xl leading-tight">
              <span className="italic text-[var(--gold)]">Legacy</span>{" "}
              <span>Content Lab</span>
            </div>
            <p className="mt-5 max-w-md text-[var(--cream)]/75 text-[0.95rem] leading-relaxed">
              Content strategy, brand voice, and AI-fluent systems for the women
              building something worth remembering.
            </p>
            <Link
              to="/book"
              className="btn-ghost-dark mt-8 inline-flex"
              data-testid="footer-cta-book"
            >
              Book Your Session →
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[var(--gold)] mb-5">Explore</p>
            <ul className="space-y-3 text-[0.95rem]">
              <li>
                <Link to="/" className="hover:text-[var(--gold)] transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[var(--gold)] transition-colors" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/book" className="hover:text-[var(--gold)] transition-colors" data-testid="footer-link-book">
                  Book Now
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[var(--gold)] mb-5">Studio</p>
            <ul className="space-y-3 text-[0.95rem] text-[var(--cream)]/80">
              <li>Khalilah</li>
              <li>CEO & AI Certified Architect</li>
              <li>By appointment only</li>
            </ul>
          </div>
        </div>

        <div className="hairline-gold mt-16" />

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[var(--cream)]/55 tracking-wide">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Legacy Content Lab. All rights reserved.
          </p>
          <p className="uppercase tracking-[0.3em]">Built with intention</p>
        </div>
      </div>
    </footer>
  );
}
